import { requestHttp } from '@/utils';

const bridgeApi = {
  DEVICE_LIST_GET_API: `/est/prod/list`, //获取网桥产品列表
  DEVICE_RECOMMEND_POST_API: '/est/prod/recommend', //获取网桥推荐产品
  SCHEME_ALLCONF_GET_API: '/est/list/all', //获取方案所有配置
  BRIDGE_CONF_ALL_API: '/est/bridge/{bridgeId}', //获取/删除网桥详情
  BRIDGE_CONF_POST_API: '/est/bridge', //保存网桥
  BRIDGE_IMG_POST_API: '/project/image/save', //保存桥组截图
  BRIDGE_IMGLIST_POST_API: '/project/image/list', //获取桥组图片
  SITE_CONF_ALL_API: '/est/site/{siteId}', //获取删除点位信息
  SITE_CONF_POST_API: '/est/site', //更新点位新信息
  SITE_CONF_BATCHADD_POST_API: '/est/site/batch' //批量添加点位信息
};

export const bridgeService = {
  getDeviceList(data = {}) {
    return requestHttp({
      api: bridgeApi.DEVICE_LIST_GET_API,
      method: 'GET',
      module: 'survey',
      querys: data.querys || {}
    });
  },
  getRecommendDevice(data = {}) {
    return requestHttp({
      api: bridgeApi.DEVICE_RECOMMEND_POST_API,
      method: 'POST',
      module: 'survey',
      params: data.params || {}
    });
  },
  /**
   * 获取方案所有配置
   * @param {*} data
   * @returns
   */
  getAllConfByScheme(data = {}) {
    return requestHttp({
      api: bridgeApi.SCHEME_ALLCONF_GET_API,
      method: 'GET',
      module: 'survey',
      querys: data.querys || {}
    });
  },
  /**
   * 获取网桥配置
   * @param {*} data
   * @returns
   */
  getBridgeConf(data = {}) {
    return requestHttp({
      api: bridgeApi.BRIDGE_CONF_ALL_API.replace('{bridgeId}', data.replace.bridgeId),
      method: 'GET',
      module: 'survey'
    });
  },
  /**
   * 桥组保存
   * @param {*} data
   * @returns
   */
  saveBridgeConf(data = {}) {
    return requestHttp({
      api: bridgeApi.BRIDGE_CONF_POST_API,
      method: 'POST',
      module: 'survey',
      params: data.params || {}
    });
  },
  /**
   * 删除网桥配置
   * @param {*} data
   * @returns
   */
  delBridgeConf(data = {}) {
    return requestHttp({
      api: bridgeApi.BRIDGE_CONF_ALL_API.replace('{bridgeId}', data.replace.bridgeId),
      method: 'DELETE',
      module: 'survey',
      params: data.params || {}
    });
  },
  /**
   * 删除点位配置
   * @param {*} data
   * @returns
   */
  delSiteConf(data = {}) {
    return requestHttp({
      api: bridgeApi.SITE_CONF_ALL_API.replace('{siteId}', data.replace.siteId),
      method: 'DELETE',
      module: 'survey'
    });
  },
  /**
   * 更新点位配置
   * @param {*} data
   * @returns
   */
  updataSiteConf(data = {}) {
    return requestHttp({
      api: bridgeApi.SITE_CONF_POST_API,
      method: 'PUT',
      module: 'survey',
      params: data.params || {}
    });
  },
  /**
   * 批量添加点位配置
   * @param {*} data
   * @returns
   */
  batchAddSiteConf(data = {}) {
    return requestHttp({
      api: bridgeApi.SITE_CONF_BATCHADD_POST_API,
      method: 'POST',
      module: 'survey',
      params: data.params || {}
    });
  },
  /**
   * 保存桥组图片
   * @param {*} data
   * @returns
   */
  bridgeImgSave(data = {}) {
    return requestHttp({
      api: bridgeApi.BRIDGE_IMG_POST_API,
      method: 'POST',
      module: 'survey',
      params: data.params || {},
      querys: data.querys || {}
    });
  },
  /**
   * 获取桥组图片
   * @param {*} data
   * @returns
   */
  getBridgeImgs(data = {}) {
    return requestHttp({
      api: bridgeApi.BRIDGE_IMGLIST_POST_API,
      method: 'POST',
      module: 'survey',
      params: data.params || {},
      querys: data.querys || {}
    });
  }
};
